import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { FilteringService } from 'src/app/services/filtering.service';
import { SupportIssue, SupportIssueNote, SupportIssueStatus } from '../models/SupportIssue';
import { SupportIssueService } from '../services/support-issue.service';

@Component({
  selector: 'app-notes-dialog',
  templateUrl: './notes-dialog.component.html',
  styleUrls: ['./notes-dialog.component.less']
})
export class NotesDialogComponent implements OnInit, AfterViewInit {

  @Input() issue: SupportIssue;
  noteToAdd: SupportIssueNote;
  private saving: boolean = false;
  @ViewChild('notesForm', {}) ngForm: NgForm;
  constructor(public issuesService: SupportIssueService, public modalService: NgbModal, public filtering: FilteringService, private toast: ToastrService, public auth: AuthService) { }


  ngAfterViewInit(): void {
    this.issuesService.fetchNotesForIssue(this.issue).subscribe((res: SupportIssueNote[]) => {
      this.issue.notes = res;
      this.sortNotes();
    },
      err => { this.toast.error('Error fetching support issue notes.', '', { closeButton: true, disableTimeOut: true }) }),
      () => { }
  }

  public get issueStatuses(): { statusId: number, statusName: string }[] {
    if(this.auth.UserInRole('Manager')) {
      return this.issuesService.issueStatuses;
    } else  
      return this.issuesService.issueStatusesNonManager;
  }

  ngOnInit() {
    this.issue.notes = [];
    this.noteToAdd = new SupportIssueNote();
    this.noteToAdd.issueId = this.issue.id;
  }



  cancel(): void {
    this.modalService.dismissAll();
  }


  save(autoResolve: boolean = false): void {
    console.log(this.ngForm);
    if (this.ngForm.form.touched) {
      this.issue.supportIssueTypeId = this.issue.issueType.id;
      this.issuesService.updateSupportIssue(this.issue).subscribe((ev: any) => {
        this.toast.success('Support issue updated');
      }, (err: any) => {
        this.toast.error('Error updating support issue.')
      })
    }

    if (!this.saving && this.noteToAdd.noteText) {
      this.saving = true;
      this.issuesService.saveNote(this.noteToAdd).subscribe((res: SupportIssueNote) => {
        res.creatingUserName = this.auth.loggedInUser.userName;
        this.issue.notes.push(res);
        this.issue.issueNoteCount = this.issue.notes.length;
        this.noteToAdd = new SupportIssueNote();
        this.noteToAdd.issueId = this.issue.id;
        this.sortNotes();
        this.saving = false;

        if(autoResolve) {
          this.issuesService.resolveIssue(this.issue);
        }
      },
        err => { this.toast.error('Error saving note!', '', { disableTimeOut: true, closeButton: true }) },
        () => {
          this.toast.success('Note saved!', '');
        });
    }


  }

  sortNotes(): void {
    this.issue.notes = _.orderBy(this.issue.notes, "createdDate", "desc");
  }

}
